import React from 'react';
import './UniversityPage.css';

const UniversityPage3 = () => {
    return (
        <>
            <div className="containerr">
                <header className="header">
                    <h1>University of Naples Federico II</h1>
                    <h2>Medicine and Surgery Program</h2>
                </header>

                <section className="overview">
                    <h2>Overview</h2>
                    <p>The University of Naples Federico II (Italian: Università degli Studi di Napoli Federico II) is a public research university in Naples, Campania, Italy. Established in 1224 and named after its founder, Frederick II, it is the oldest public, secular, non-sectarian or state-funded university in the world, and one of the world's ten oldest universities in continuous operation.</p>
                    <p>It was Europe's first university dedicated to training secular administrative staff, and is one of the world's oldest academic institutions in continuous operation. With over 90,000 students (2022), it is among the largest universities in Europe.</p>
                </section>

                <section className="ranking">
                    <h2>International Ranking of UniNA</h2>
                    <p>University of Naples - Federico II is one of the top public universities in Naples, Italy. In the newly released QS World University Ranking 2025, the University of Naples Federico II ranks 347 globally and 6th in Italy. It is among the top 201-250 in the field of Medicine.</p>
                </section>

                <section className="admission">
                    <h2>Admission Requirements</h2>
                    <p>Prospective students must meet the following requirements:</p>
                    <ul>
                        <li>A high school diploma equivalent to the Italian secondary school qualification. Minimum score should be 70%.</li>
                        <li>DOV (Declaration of Value).</li>
                        <li>A valid IMAT score above the cutoff for their category (EU/non-EU).</li>
                        <li>Proof of English proficiency (for non-native speakers).</li>
                        <li>Visa and residence permit for non-EU students.</li>
                    </ul>
                    <section className="ranking">
                    <h2>Seats Available</h2>
                    <p>The medical program at UniNA has only 40 seats available for both EU and Non-
EU students, which makes it highly competitive. Both EU and non-EU students

must qualify through the IMAT (International Medical Admissions Test) to secure
a seat.</p>
               
                    <table>
                        <thead>
                            <tr>
                                <th>Non-EU seats</th>
                                <th>EU seats</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>25</td>
                                <td>15</td>
                            </tr>
                        </tbody>
                    </table>
                    </section>

                    <section className="ranking">
                    <h3>IMAT Scores in Past Years and Cut-offs</h3>
                    <table>
                        <thead>
                            <tr>
                                <th>Year</th>
                                <th>Minimum Score (Non-European)</th>
                                <th>European Scores (First/Last Round)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>2020</td>
                                <td>31.1</td>
                                <td>First: 56.4 / Last: 42.0</td>
                            </tr>
                            <tr>
                                <td>2021</td>
                                <td>41.4</td>
                                <td>First: 50.5 / Last: 34.4</td>
                            </tr>
                            <tr>
                                <td>2022</td>
                                <td>44.4</td>
                                <td>First: 48.1 / Last: 37.1</td>
                            </tr>
                            <tr>
                                <td>2023</td>
                                <td>52</td>
                                <td>First: 45.2 / Last: 45.2</td>
                            </tr>
                            <tr>
                                <td>2024</td>
                                <td>68.1</td>
                                <td>First: 64.0 / Last: 61.4</td>
                            </tr>
                        </tbody>
                    </table>

                  
                </section>
                </section>

                <section className="course-structure">
    <h2>Course Structure and Subjects Taught</h2>
    <p>The Medicine and Surgery course at UniNA aims at providing scientific, theoretical, and practical skills, along with the professional and decisional autonomy necessary for the medical profession.</p>

    <h3>1st Year</h3>
    <ul>
        <li>Bioethics</li>
        <li>Chemistry & Propedeutical Biochemistry</li>
        <li>Physics in Medicine</li>
        <li>Medical Statistics & Informatics</li>
        <li>Molecular & Cellular Biology</li>
        <li>Human Histology & Embryology</li>
        <li>Human Anatomy I</li>
        <li>Scientific English I</li>
    </ul>
    <p><strong>Assessment:</strong> At the end of the course, a written test and oral examination will be conducted.</p>

    <h3>2nd Year</h3>
    <ul>
        <li>Human Anatomy II</li>
        <li>Human Biochemistry</li>
        <li>Scientific English I</li>
        <li>Human Physiology I</li>
        <li>Microbiology & Immunology</li>
        <li>Human & Medical Genetics</li>
    </ul>
    <p><strong>Assessment:</strong> At the end of the course, a written test and oral examination will be conducted.</p>

    <h3>3rd Year</h3>
    <ul>
        <li>Human Physiology II</li>
        <li>General Pathology</li>
        <li>Medical, Surgical, Clinical Methodology I</li>
        <li>Medical, Surgical, Clinical Methodology II</li>
        <li>General Pathophysiology</li>
        <li>Hygienes & Community Medicine</li>
        <li>Laboratory Medicine</li>
    </ul>
    <p><strong>Assessment:</strong> At the end of the course, a written test and oral examination will be conducted.</p>

    <h3>4th Year</h3>
    <ul>
        <li>Medical Pharmacology & Toxicology I</li>
        <li>Medical Pharmacology & Toxicology II</li>
        <li>Pathological Anatomy & Histology I</li>
        <li>Pathological Anatomy & Histology II</li>
        <li>Clinical Immunology & Allergology, Cutaneous and Venereal Diseases & Plastic Surgery</li>
        <li>Endocrine & Gastrointestinal Diseases</li>
        <li>Respiratory & Cardiovascular Diseases</li>
        <li>Urological Diseases</li>
    </ul>
    <p><strong>Assessment:</strong> At the end of the course, a written test and oral examination will be conducted.</p>

    <h3>5th Year</h3>
    <ul>
        <li>Head & Neck & Sensory Organ Diseases</li>
        <li>Rheumatology & Degenerative-Malformative Diseases of Locomotor System</li>
        <li>Imaging Diagnostics and Radiotherapy</li>
        <li>Forensic & Occupational Medicine</li>
        <li>Neurology & Psychiatry</li>
        <li>Infectious Diseases</li>
        <li>Translational Medicine</li>
        <li>Oncological & Hematological Diseases</li>
    </ul>
    <p><strong>Assessment:</strong> At the end of the course, a written test and oral examination will be conducted.</p>

    <h3>6th Year</h3>
    <ul>
        <li>Clinical Medicine</li>
        <li>Pediatrics</li>
        <li>General Surgery</li>
        <li>Gynecology & Obstetrics</li>
        <li>Medical & Surgical Emergencies</li>
    </ul>
    <p><strong>Assessment:</strong> At the end of the course, a written test and oral examination will be conducted.</p>

    <h3>Final Assessment</h3>
    <p>In order to be admitted to their graduation exams, the students will need to:</p>
    <ol>
        <li>Attend all classes and pass every exam.</li>
        <li>Obtain 360 total ECTs in 6 years of classes.</li>
        <li>20 days before the graduation, a copy of the thesis must be provided.</li>
    </ol>
</section>

                <section className="exams">
                    <h2>Exams</h2>
                    <p><strong>Written Exams:</strong> Each course typically culminates in a written exam, which may include multiple-choice questions, short-answer questions, or problem-solving tasks. These assessments are designed to evaluate a student's understanding of core concepts in medical science.</p>
                    <p><strong>Oral Exams:</strong> Following the written portion, students must typically undergo an oral exam. This serves as an opportunity for professors to probe deeper into a student's understanding, testing their ability to explain and discuss key medical concepts with clarity and depth.</p>
                </section>

                <section className="scholarships">
                    <h2>Tuition Fees and Scholarships</h2>
                    <p><strong>EU students:</strong> €200/year (university fees) + €140/year regional tax (compulsory) + €16.00 legal stamp (compulsory).</p>
                    <p><strong>Non-EU students:</strong> €140/year regional tax (compulsory) + €16.00 legal stamp (compulsory).</p>
                    <p><strong>Scholarships:</strong> Managed by ADISURC: <a href="https://www.adisurcampania.it/">ADISURC Scholarships</a></p>
                </section>

                <section className="city-info">
                    <h2>Naples as a City</h2>
                    <p>Naples is a city that’s full of life, history, and character—it’s a place where every corner tells a story. Its historic charm, vibrant streets and neighborhoods, food, coast, and views make it an attractive destination for students.</p>
                </section>

                <section className="living-expenses">
                    <h2>Living Expenses and International Life in Naples</h2>
                    <ul>
                        <li><strong>Cost of living:</strong> Shared apartments range from €300-600 per month depending on location and amenities.</li>
                        <li><strong>Food and dining:</strong> Weekly grocery expenses average €30-60.</li>
                        <li><strong>Transportation:</strong> Bus, tram, and metro services are available. Students can have a bus pass for €35-€50 depending on the time period.</li>
                        <li><strong>Social Life:</strong> The social life in Naples is full of energy, local charm, and opportunities to meet new people. The city offers a dynamic mix of modern entertainment, cultural activities, and lively events.</li>
                    </ul>
                </section>

                <footer className="footer">
                    <h2>Conclusion</h2>
                    <p>Living in Naples while studying at the University of Naples Federico II offers a perfect mix of quality education and vibrant city life. With affordable living, a welcoming student community, and a rich cultural backdrop, Naples provides an exciting environment for personal and academic growth. A great choice for those seeking adventure, culture, and academic excellence.</p>
                </footer>
            </div>
        </>
    );
};

export default UniversityPage3;